"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const snowplow_js_common_1 = require("@angi/snowplow-js-common");
const SnowplowProvider_1 = require("../SnowplowProvider");
/**
 * Used to set enablePageView and dependencies to default values if none are passed in
 */
const defaultParams = {
    enablePageView: true,
    dependencies: [],
};
/**
 * React app page view event. Uses a React useEffect hook with passed in dependencies to
 * manage the amount of page view calls
 *
 * @param params - object of possible values to pass to this method. Page view is required
 */
const useEnhancedPageView = (params) => {
    const { enablePageView, dependencies, pageName, pageViewContexts } = Object.assign(Object.assign({}, defaultParams), params);
    const isSnowplowReady = (0, SnowplowProvider_1.useIsSnowplowReady)();
    (0, react_1.useEffect)(() => {
        if (enablePageView && isSnowplowReady) {
            const pageContext = (0, snowplow_js_common_1.pageAttributesContext)(pageName);
            window.snowplow.core.addGlobalContexts([pageContext]);
            (0, snowplow_js_common_1.enhancedPageView)(pageViewContexts);
            return () => {
                window.snowplow.core.removeGlobalContexts([pageContext]);
            };
        }
    }, [...dependencies, isSnowplowReady]);
};
exports.default = useEnhancedPageView;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRW5oYW5jZWRQYWdlVmlldy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VFbmhhbmNlZFBhZ2VWaWV3LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsaUNBQWtDO0FBQ2xDLGlFQUFtRjtBQUNuRiwwREFBeUQ7QUFHekQ7O0dBRUc7QUFDSCxNQUFNLGFBQWEsR0FBRztJQUNsQixjQUFjLEVBQUUsSUFBSTtJQUNwQixZQUFZLEVBQUUsRUFBRTtDQUNuQixDQUFDO0FBRUY7Ozs7O0dBS0c7QUFDSCxNQUFNLG1CQUFtQixHQUFHLENBQUMsTUFBaUMsRUFBUSxFQUFFO0lBQ3BFLE1BQU0sRUFBRSxjQUFjLEVBQUUsWUFBWSxFQUFFLFFBQVEsRUFBRSxnQkFBZ0IsRUFBRSxtQ0FDM0QsYUFBYSxHQUNiLE1BQU0sQ0FDWixDQUFDO0lBRUYsTUFBTSxlQUFlLEdBQUcsSUFBQSxxQ0FBa0IsR0FBRSxDQUFDO0lBRTdDLElBQUEsaUJBQVMsRUFBQyxHQUFHLEVBQUU7UUFDWCxJQUFJLGNBQWMsSUFBSSxlQUFlLEVBQUU7WUFDbkMsTUFBTSxXQUFXLEdBQUcsSUFBQSwwQ0FBcUIsRUFBQyxRQUFRLENBQUMsQ0FBQztZQUNwRCxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUM7WUFFdEQsSUFBQSxxQ0FBZ0IsRUFBQyxnQkFBZ0IsQ0FBQyxDQUFDO1lBRW5DLE9BQU8sR0FBRyxFQUFFO2dCQUNSLE1BQU0sQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLG9CQUFvQixDQUFDLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQztZQUM3RCxDQUFDLENBQUM7U0FDTDtJQUNMLENBQUMsRUFBRSxDQUFDLEdBQUcsWUFBWSxFQUFFLGVBQWUsQ0FBQyxDQUFDLENBQUM7QUFDM0MsQ0FBQyxDQUFDO0FBRUYsa0JBQWUsbUJBQW1CLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../../src/react/hooks/useEnhancedPageView.ts